import { InvokeCallback, Sender } from "xstate";
import {
  CreateMultipleBookingParams,
  createBookings,
} from "@rentablo/api/apiv1";
import { withToken } from "@rentablo/api";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";

export const saveDividends =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  (callback) => {
    if (event.type !== "PERSIST") {
      throw new Error(`Invalid event type ${event.type}`);
    }

    if (!context.validatedMultipleBookingParams) {
      throw new Error(`Invalid multiply booking params`);
    }

    save(context.validatedMultipleBookingParams, callback);
  };

const save = async (
  createMultipleBookingParams: CreateMultipleBookingParams,
  callback: Sender<DividendWizardEvent>
) => {
  try {
    await withToken(createBookings)({ createMultipleBookingParams });

    callback({ type: "SUCCESS" });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
